import "./tag-color.scss";

import { RegistrationStatus } from "@core/model/registration-status.enum";
import { TransactionAction } from "@core/model/transaction-action.enum";
import classNames from "classnames";
import { Tag } from "primereact/tag";

export interface TagColorProps {
  value: string;
}

export function TagColor({ value }: TagColorProps) {
  const mapColor = {
    ["0"]: "bg-blue-500",
    ["1"]: "bg-green-500",
    ["OR"]: "bg-blue-500",
    ["AND"]: "bg-green-500",
    [TransactionAction.Earn]: "bg-green-500",
    [TransactionAction.Redeem]: "bg-violet-500",
    [RegistrationStatus.PENDING]: "bg-blue-500",
    [RegistrationStatus.PROCESSED]: "bg-green-500",
  };
  const mapLabel = {
    ["0"]: "No",
    ["1"]: "Yes",
    ["OR"]: "OR",
    ["AND"]: "AND",
    [TransactionAction.Earn]: TransactionAction.Earn,
    [TransactionAction.Redeem]: TransactionAction.Redeem,
    [RegistrationStatus.PENDING]: "Pending",
    [RegistrationStatus.PROCESSED]: "Processed",
  };

  return (
    <div id="TagColor" className="tag-color">
      <Tag className={classNames(mapColor[value as keyof typeof mapColor])}>
        <div className="flex align-items-center gap-2">
          {mapLabel[value as keyof typeof mapLabel]}
        </div>
      </Tag>
    </div>
  );
}

export default TagColor;
